import { getItems } from 'common/api/politicalDivisions';

import {
    FETCH_POLITICAL_DIVISIONS2,
    FETCH_POLITICAL_DIVISIONS2_FAILURE,
    FETCH_POLITICAL_DIVISIONS2_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default ({ country, political_division } = {}) =>
    (dispatch) => {
        dispatch(actions[FETCH_POLITICAL_DIVISIONS2]());

        getItems({ country, political_division })
            .then((response) => {
                dispatch(
                    actions[FETCH_POLITICAL_DIVISIONS2_SUCCESS](
                        response.data.data,
                    ),
                );
            })
            .catch((error) =>
                dispatch(
                    actions[FETCH_POLITICAL_DIVISIONS2_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
